<template>
    <v-form :name="searchProps.formName"
            @keyup.enter="autoSearch = true">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Search condition')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormMultiselect fieldName="worker_id"
                                     label="Worker"
                                     size="6"
                                     :options="select?.workers"
                                     v-model:field="search.worker_id" />

                    <FormCalendar fieldName="assessment_from"
                                  label="From day"
                                  size="2"
                                  v-model:field="search.assessment_from" />

                    <FormCalendar fieldName="assessment_to"
                                  label="To day"
                                  size="2"
                                  v-model:field="search.assessment_to" />

                    <FormInputToggleButton fieldName="is_active"
                                           label="Is active?"
                                           size="2"
                                           v-model:field="search.is_active" />
                </div>
            </TabPanel>
        </TabView>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SearchButtons from '@crud/SearchButtons.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import { prepareSearch, onFilterService } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})

const autoSearch = ref(false)
const options = ["workers"];
const select = ref(null);

let search = ref({})
prepareSearch(search, props, options, select)

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading)
}

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
